<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer"
            [routerLink]="['/vehicle-management/taxi/monthly-report']"></i>

        <span class="my-auto f16 fw-bold me-2"> جزئیات عملکرد ماهیانه - {{ lst_Report[0]?.strFullName }} </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <form class="row gx-2 gy-3" [formGroup]="mdl_Search">

        <!-- از تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> از تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input type="text" formControlName="strSDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- تا تاریخ -->

        <div class="col-12 col-md-2 position-relative">

            <label> تا تاریخ </label>

            <ng-persian-datepicker [uiTheme]="'gray'" [timeEnable]="false" [dateGregorianFormat]="'YYYY/MM/DD'"
                [dateInitValue]="true" [dateFormat]="'jYYYY/jMM/jDD'">

                <input formControlName="strEDate" placeholder="از تاریخ" class="form-control text-end" />

            </ng-persian-datepicker>

        </div>

        <!-- جستجو -->

        <div class="col-12 col-md-1 position-relative border border-2 b-transparent">

            <button class="btn btn-primary w-100" (click)="search_Report()">

                <small> جستجو </small>

            </button>

        </div>

        <!-- خروجی اکسل -->

        <div class="col-12 col-md-auto position-relative border border-2 b-transparent">

            <button class="btn btn-success w-100" (click)="exportExcel('Export_Excel')">

                <small> &nbsp; خروجی اکسل &nbsp; </small>

            </button>

        </div>

    </form>

    <div class="border border-2 mt-3 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <div class="col-12">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                    (keyup)="filter_list($event.target)">

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 260px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center col-1"> عملیات </th>

                        <th class="text-center"> تاریخ </th>

                        <th class="text-center"> روز </th>

                        <th class="text-center"> نام خط </th>

                        <th class="text-center"> اولین ورود </th>

                        <th class="text-center"> آخرین خروج </th>

                        <th class="text-center"> مدت حضور </th>

                        <th class="text-center pointer" (click)="sortfKmTotal()">

                            <i class="fa fa-sort"></i>

                            پیمایش(km)

                        </th>

                        <th class="text-center pointer" (click)="sortfADT()">

                            <i class="fa fa-sort"></i>

                            کارایی

                        </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <th class="">

                            <i class="fa fa-info-circle fs-5 pointer" title="مشخصات" (click)="openDetails(item)"></i>

                        </th>

                        <td> {{ item.strDate | faNum }} </td>

                        <td [innerHTML]="highlightText(item.strDayName,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strBusLineName,searchTerm.value) | faNum"> </td>

                        <td> {{ item.strStartTime | faNum }} </td>

                        <td> {{ item.strEndTime | faNum }} </td>

                        <td> {{ item.strPresentTime | faNum }} </td>

                        <td> {{ item.fKmTotal.toFixed(2) | faNum }} </td>

                        <td> {{ item.fADT.toFixed(2) | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

        <div class="row gx-0 gy-0 p-2 bg-secondary">

            <span class="col-md-auto col-12 text-white ms-md-3">

                تعداد : {{ lst_Report.length | number:'1.0-0' | faNum }}

            </span>

            <span class="col-md-auto col-12 text-white ms-md-3">

                سرجمع پیمایش : {{ fKmTotal | number:'1.0-0' | faNum}} کیلومتر

            </span>

            <span class="col-md-auto col-12 text-white ms-md-3">

                سرجمع مدت حضور : {{ fHours | number:'1.0-0' | faNum}} ساعت

            </span>

            <span class="col-md-auto col-12 text-white ms-md-3">

                متوسط کارایی : <span dir="ltr"> {{ (fADT) |number:'1.0-0' | faNum }} </span>

            </span>

        </div>

    </div>

</main>

<div class="modal fade" id="viewModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">

    <div class="modal-dialog modal-lg">

        <div class="modal-content dirI">

            <div class="modal-header dirI">

                <h5 class="modal-title" id="exampleModalLabel"> سوابق ورود و خروج </h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="section border border-2">

                    <table class="col-12 table table-striped rounded-3">

                        <thead>

                            <tr class="">

                                <th class="text-center col-1"> # </th>

                                <th class="text-center"> ورود </th>

                                <th class="text-center"> خروج </th>

                                <th class="text-center"> مدت حضور </th>

                            </tr>

                        </thead>

                        <tbody>

                            <tr class="col-12 text-center" *ngFor="let item of lst_EntryExit;let i = index">

                                <th> {{ i + 1 | faNum }} </th>

                                <td> {{ item.entry | faNum }} </td>

                                <td> {{ item.exit | faNum }} </td>

                                <td> {{ item.duration | faNum }} </td>

                            </tr>

                        </tbody>

                    </table>

                </div>

            </div>

            <div class="modal-footer d-flex justify-content-start">

                <button class="btn btn-outline-secondary" data-bs-dismiss="modal">

                    &nbsp; بستن &nbsp;

                </button>

            </div>

        </div>

    </div>

</div>